import { ApolloProvider } from '@apollo/client';
import { useSession } from '@descope/react-sdk';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { createApolloClient } from '../../services/apollo-client';

interface ApolloClientProviderProps {
  endpoint: string;
  connectToDevTools?: boolean;
}

export function ApolloClientProvider({
  children,
  connectToDevTools = false,
  endpoint,
}: PropsWithChildren<ApolloClientProviderProps>) {
  const { sessionToken } = useSession();
  const client = useMemo(
    () => createApolloClient({ endpoint, sessionToken, connectToDevTools }),
    [connectToDevTools, endpoint, sessionToken],
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
